module.exports = __webpack_public_path__ + "media/images/photos/headlight-being-repaired-799a505ed7c6cc55c260e38c36af3f89.jpg";